import { ErrorTypes, FlattenedErrorsObjectArray, LockIcon } from '@equifinance/shared';
import { ReactNode } from 'react';
import { CrossCircleIcon, TickCircleIconInverted } from '../components/Icons';

export type SectionTitleIconProps = {
  errors?: FlattenedErrorsObjectArray,
  isCompleted?: boolean,
  isLocked?: boolean,
  showDefault?: boolean,
  lockIcon?: ReactNode,
  tickIcon?: ReactNode,
  crossIcon?: ReactNode,
}

export function SectionTitleIcon({
  errors = [],
  isCompleted = true,
  isLocked = false,
  showDefault = false,
  lockIcon = <LockIcon />,
  tickIcon = <TickCircleIconInverted />,
  crossIcon = <CrossCircleIcon />,
}: SectionTitleIconProps) {
  const hasValidationFailures = errors.some((error) => error.errorType === ErrorTypes.ValidationFailure);
  const hasRejectData = errors.some((error) => error.errorType === ErrorTypes.RejectData);

  if (!isLocked) {
    return (!isCompleted || ((hasValidationFailures || hasRejectData) && !showDefault))
      ? (<>{ crossIcon }</>)
      : (<>{ tickIcon }</>);
  }
  return <>{ lockIcon }</>;
}
